import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import { contentWidth } from "../constants";

const ContentRef = ({ children, id, margin }) => {
  const [hovered, setHovered] = useState(false);
  const [hasClicked, setHasClicked] = useState(false);
  useEffect(() => {
    if (hasClicked) {
      setTimeout(() => setHasClicked(false), 1000);
    }
  }, [hasClicked]);
  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      class="flex flex-row flex-start mb-2 justify-start"
    >
      <div
        class="h-full text-gray-500 border-b border-white hover:text-black hover:border-gray-500 p-0.5 transition duration-100 cursor-pointer select-none"
        style={{
          visibility: hovered ? "visible" : "hidden",
          fontFamily: "EB Garamond",
          position: "relative",
        }}
        onClick={() => {
          setHasClicked(true);
          navigator.clipboard.writeText(
            window.location.href.split("#")[0] + "#" + id
          );
        }}
      >
        §
        <div
          class="bg-gray-50 rounded p-0.5 whitespace-nowrap my-2"
          style={{
            position: "absolute",
            // fontSize: "12px",
            right: 0,
            visibility: hasClicked ? "visible" : "hidden",
            opacity: hasClicked ? 1 : 0,
            transition: hasClicked ? "none" : "0.3s ease-in-out",
          }}
        >
          Link copied!
        </div>
      </div>
      <div class="w-full flex flex-row font-serif">
        <div
          style={{
            textIndent: "2em",
            textJustify: "inter-word",
            textAlign: "justify",
            maxWidth: contentWidth,
            width: "70%",
          }}
        >
          <div class="text-lg px-2">
            <div
              class="linkable"
              id={id}
              style={{
                display: "inline",
                transition: "0.3s ease-in-out",
                ...(hasClicked && {
                  backgroundColor: "rgba(255, 240, 0, 0.25)",
                  transition: "none",
                }),
              }}
            >
              {children}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "20%",
            textIndent: "2em",
            textJustify: "inter-word",
            textAlign: "justify",
          }}
        >
          <p
            class="text-sm ml-1 mt-1"
            style={{
              textIndent: "1em",
              textAlign: "left",
              visibility: margin ? "visible" : "hidden",
              maxWidth: "8rem",
            }}
          >
            {margin}
          </p>
        </div>
      </div>
    </div>
  );
};
export default ContentRef;
